import { ComponentStyleConfig } from '@chakra-ui/react';
import { FormControlConfig } from 'shared/hocs/FormControl/formControl.config';

export const SelectConfig: ComponentStyleConfig = {
  ...FormControlConfig,
};
